import { setElementIsEdited } from '../../helpers';
import { HtmlTextFieldsConfig } from './getData';
import { modifyElementContent } from '../../editableTextFields/saveData';
import { editableId } from '../constants';

const modifyEmptyParagraphs = (fieldElement: HTMLElement): void => {
	const emptyParagraphs = [...fieldElement.querySelectorAll('p')].filter(p => !p.innerText);

	emptyParagraphs.forEach((paragraph) => {
		const brElement = document.createElement('br');
		paragraph.parentNode!.replaceChild(brElement, paragraph);
	});
};

export default (htmlDocument: Document, fields: HtmlTextFieldsConfig[]): void => {
	fields.forEach(({ id, content, isEditedFromBackoffice }) => {
		if (!isEditedFromBackoffice) {
			return;
		}

		const fieldElement = htmlDocument.querySelector(`[${editableId}=${id}]`) as HTMLElement;
		if (fieldElement) {
			setElementIsEdited(fieldElement);
			fieldElement.innerHTML = content;
			modifyElementContent(fieldElement, modifyEmptyParagraphs);
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/htmlEditor/editableTextFields/saveData.ts